import { Avatar, IconButton, Tooltip } from "@mui/material"
import { DamsAppAsset } from "../../assets/registry"
import { DamsColors } from "../styles/DamsColors"




function TableActionIcon({
    IconSrc,
    onIconClick,
    ariaLabel,
    children,
    tip
}:
    Readonly<{
        IconSrc?: string,
        onIconClick?: () => void,
        ariaLabel?: string,
        children?: React.ReactNode
        tip?:string
    }>) {

    return (
    <Tooltip title={tip}>
        <IconButton
            aria-label={`${ariaLabel}`}
            size="small"
            onClick={() => {
                if (onIconClick !== undefined) { onIconClick() }
            }}
        >
            {children ||
                (
                    <Avatar
                        variant="square"
                        sx={styles.iconStyle}
                        src={IconSrc}
                        alt="edit"
                    />

                )}

        </IconButton></Tooltip>
    )

}



const styles = {
    iconStyle: {
        height: '20px',
        width: '20px',
        color: DamsColors.Text.LabelTextLight
    },
}

export { TableActionIcon }
